import {
  InstallmentSettleFormValues,
  SettleInstallmentSingleData,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { Col, Form, FormInstance, Row, Statistic } from 'antd';
import React from 'react';
import {
  FloatingFormItem,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import BankAccountInfiniteSelectField from '@/components/_common/BankAccountInfiniteSelectField';
import DocumentTypesInfiniteSelectField from '@/components/_common/DocumentTypesInfiniteSelectField';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  form: FormInstance<InstallmentSettleFormValues>;
  data?: SettleInstallmentSingleData;
}

const SettleSingleAccountPayableForm: React.FC<Props> = ({ form, data }) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Form form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <FloatingFormItem
            name={'bankAccountId'}
            label={'Conta bancária'}
            rules={[defaultEmptyFieldError]}
          >
            <BankAccountInfiniteSelectField queryFilter={{ active: true }} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name={'documentTypeId'}
            label={'Tipos de Documento'}
            rules={[defaultEmptyFieldError]}
          >
            <DocumentTypesInfiniteSelectField queryFilter={{ active: true }} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="payDate"
            label="Dt. de Pagamento"
            rules={[defaultEmptyFieldError]}
          >
            <InputDate
              disabled={
                !hasPermissions([
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_EDIT_DATE_SETTLE_INSTALLMENT,
                ])
              }
            />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="discountIncrease"
            label="Acres./Desc."
            initialValue={0}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const discount = Number(getFieldValue('discountIncrease') ?? 0);

              let total = 0;

              if (data) {
                total =
                  (data.installmentValue ?? 0) +
                  (discount ?? 0) -
                  (data.credit ?? 0);
              }

              return (
                <Statistic
                  title="Total a pagar"
                  value={total}
                  formatter={(value) => formatterPrice(Number(value))}
                  valueStyle={{
                    color: '#148e28',
                  }}
                />
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default SettleSingleAccountPayableForm;
